import React from 'react';
import '../../css/RegistrationProgressBar.css';

function RegistrationProgressBar({ elements }) {
    const stageClassNameMap = {
        "check": "registrationProgressStageCheck",
        "dot_blue": "registrationProgressStageDotBlue",
        "dot_grey": "registrationProgressStageDotGrey",
    };
    const barClassNameMap = {
        "bar_white": "registrationProgressBarWhite",
        "bar_blue": "registrationProgressBarBlue",
        "bar_grey": "registrationProgressBarGrey",
    };


    const renderStage = (prevBar, element, nextBar) => {
        return (
            <div className="registrationProgressStageWrapper">
                <div className="registrationProgressStageIcon">
                    <div className={barClassNameMap[prevBar]}/>
                    <div className={stageClassNameMap[element.icon]}/>
                    <div className={barClassNameMap[nextBar]}/>
                </div>
                <div className="registrationProgressStageLabel">{element.label}</div>
            </div>
        )
    }

    const renderBar = (element) => {
        return (
            <div className="registrationProgressBarWrapper">
                <div className="registrationProgressBarIcon">
                    <div className={barClassNameMap[element.icon]}/>
                </div>
                <div className="registrationProgressBarLabel"></div>
            </div>
        )
    }

    const renderElement = (index) => {
        if (elements[index].icon in stageClassNameMap) {
            const prevElement = (index === 0) ? "bar_white" : elements[index - 1].icon;
            const nextElement = (index === elements.length - 1) ? "bar_white" : elements[index + 1].icon;
            return renderStage(prevElement, elements[index], nextElement);
        } else if (elements[index].icon in barClassNameMap) {
            return renderBar(elements[index]);
        } else {
            return null;
        }
    }

    const renderElements = () => {
        const rendered = [];
        for (let i = 0; i < elements.length; i++) {
            rendered.push(renderElement(i));
        }
        return rendered;
    };

    return (
        <div className="registrationProgressBarContainer">
            {renderElements()}
        </div>
    );
}

export default RegistrationProgressBar;
